import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title text-center">
            <h2>
              Get In <span>Touch</span>
            </h2>
            <hr style={{ margin: "0 auto 20px", width: "70px" }} />
            <p>
              நேரில் வருக அல்லது அழைக்கவும் — we're happy to help with any
              query.
            </p>
          </div>

          <div className="contact-grid">
            {/* Phone */}
            <a href="tel:+919042011186" className="contact-card">
              <div className="contact-icon">
                <i className="fa fa-phone"></i>
              </div>
              <h3>Call Us</h3>
              <p>+91 90420 11186</p>
            </a>

            {/* Email */}
            <a
              href="mailto:gurunathanelectronics@gmail.com?subject=Enquiry%20from%20Website&body=Hi%2C%20I%20would%20like%20to%20know%20more%20about..."
              className="contact-card"
            >
              <div className="contact-icon">
                <i className="fa fa-envelope-o"></i>
              </div>
              <h3>Email Us</h3>
              <p>gurunathanelectronics@gmail.com</p>
            </a>

            {/* Address */}
            <a
              href="https://maps.google.com/?q=Gurunathan+Electronics+Usilampatti+Road+Peraiyur"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card"
            >
              <div className="contact-icon">
                <i className="fa fa-map-marker"></i>
              </div>
              <h3>Visit Us</h3>
              <p>
                Usilampatti Road, Opp. Peraiyur Police Station, Peraiyur-625703,
                Madurai
              </p>
            </a>
          </div>

          <div className="social">
            <ul>
              <li>
                <a
                  href="https://wa.me/919042011186"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                >
                  <i className="fa fa-whatsapp"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/gurunathan_electronicsofficial?igsh=YjFkbDlkZXdoZ2Zw"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fa fa-instagram"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/share/p/18yqrqJphi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fa fa-facebook"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="footer" className="py-3 bg-dark">
        <div className="container text-center">
          <p className="mb-0 text-white">
            &copy; 2026 <strong>Gurunathan Electronics</strong>. All Rights
            Reserved.
            <br />
            Maintained by{" "}
            <a
              href="https://pixelmindsoftware.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="fw-bold text-decoration-none"
              style={{ color: "#4dabf7" }}
            >
              Pixelmind Software Solutions
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
